import type { ImgHTMLAttributes } from "react";
import { optimizedImages, type ResponsiveImage } from "@/data/optimized-images";

type OptimizedImageProps = ImgHTMLAttributes<HTMLImageElement> & {
  image?: ResponsiveImage;
  avifSrcSet?: string;
  webpSrcSet?: string;
};

export function OptimizedImage({
  image,
  avifSrcSet,
  webpSrcSet,
  sizes,
  src,
  width,
  height,
  className,
  ...rest
}: OptimizedImageProps) {
  const avif = avifSrcSet ?? image?.avifSrcSet;
  const webp = webpSrcSet ?? image?.webpSrcSet;
  const resolvedSizes = sizes ?? image?.sizes;

  return (
    <picture className="contents">
      {avif ? <source type="image/avif" srcSet={avif} sizes={resolvedSizes} /> : null}
      {webp ? <source type="image/webp" srcSet={webp} sizes={resolvedSizes} /> : null}
      <img
        src={src ?? image?.src}
        width={width ?? image?.width}
        height={height ?? image?.height}
        sizes={resolvedSizes}
        className={className}
        {...rest}
      />
    </picture>
  );
}

export function HeroPhoto({
  alt,
  className = "size-full object-cover",
  fetchPriority = "high",
  loading,
}: {
  alt: string;
  className?: string;
  fetchPriority?: "high" | "low" | "auto";
  loading?: "lazy" | "eager";
}) {
  return (
    <OptimizedImage
      image={optimizedImages.heroResort}
      alt={alt}
      fetchPriority={fetchPriority}
      loading={loading}
      decoding="async"
      className={className}
    />
  );
}
